<app-lead-magnet-widget [entry]="entry">
    <div desktop>
        <app-lead-magnet-form [leadMagnet]="entry"></app-lead-magnet-form>
    </div>
    <div mobile>
        <app-lead-magnet-form [leadMagnet]="entry"></app-lead-magnet-form>
    </div>
</app-lead-magnet-widget>
